import HeroCarousel from './components/HeroCarousel';
import createHowItWorksCarousel from './components/hiw-carousel';
import once from 'lodash/once';
import createScrollableElements, {
    centerAlignScrollableElement,
    scrollOnHover,
} from './components/scrollable';
import createProductFeatures from './components/product-features';
import Accordion from './components/Accordion';
import ScrollToElement from './components/ScrollToElement';
import { scrollToElement } from 'common/utils/scroll';
import { trackEvent, trackLink } from '@99designs/common/utils/platform';
import FeaturedContestInspiration from './components/FeaturedContestInspiration';
import SlideCarousel from './components/slide-carousel';
import ScrollDepthTracking from 'marketing/utils/ScrollDepthTracking';
import { initDesignerQuotesList } from 'marketing/components/DesignerQuotesList';
import StickyBar from './components/StickyBar';
import Waypoint from 'waypoints/lib/noframework.waypoints';
import { init as InitGetStartedInteractive } from 'interactive/get-started-interactive';

// Enable Logo+ Interactive if present
document.addEventListener('DOMContentLoaded', () => {
    const interactiveElement = document.getElementById('get_started_interactive');

    // return early if not interactive
    if (!interactiveElement) {
        return;
    }

    const key = interactiveElement.getAttribute('data-get-started-interactive-category-key');
    const CTAs = document.querySelectorAll('[data-product-cta]');

    InitGetStartedInteractive({
        container: interactiveElement.querySelector('[data-get-started-interactive-inner]'),
        variant: interactiveElement.getAttribute('data-get-started-interactive'),
        categoryKey: key,
    });

    const triggerCtaToInteractiveEvent = () => {
        let customEvent;
        if (typeof Event === 'function') {
            customEvent = new Event('CtaToInteractive');
        } else {
            // For IE11
            customEvent = document.createEvent('Event');
            customEvent.initEvent('CtaToInteractive', true, true);
        }

        window.dispatchEvent(customEvent);
    };

    Array.from(CTAs).forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();

            trackEvent('Clicked CTA on Product page', {
                cta_location: link.getAttribute('data-product-cta-location'),
            });

            // scroll up
            scrollToElement(interactiveElement, 0, 500, triggerCtaToInteractiveEvent);
        });
    });
});

// Hero scroll to HIW link
document.addEventListener('DOMContentLoaded', () => {
    const scrollToLinks = document.querySelectorAll('[data-hero-scrollto-link]');

    for (var i = 0; i < scrollToLinks.length; i++) {
        new ScrollToElement(scrollToLinks[i]).handleClick();
    }

    new FeaturedContestInspiration();
});

document.addEventListener('DOMContentLoaded', () => {
    const interactiveElement = document.querySelector('[data-get-started-interactive]');

    // return early if interactive
    if (interactiveElement) {
        return;
    }
    const productCTA = document.querySelectorAll('[data-product-cta]');

    Array.from(productCTA).forEach(element => {
        trackLink(element, 'Clicked CTA on Product page', {
            cta_location: element.getAttribute('data-product-cta-location'),
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // Track FAQ usage to Segment
    const accordionTriggers = document.querySelectorAll('#faqs [data-accordion-item-trigger]');

    for (var i = 0; i < accordionTriggers.length; i++) {
        const trigger = accordionTriggers[i];

        trigger.addEventListener('click', e =>
            trackEvent('Clicked FAQ on Product Page', {
                title: trigger.textContent.trim(),
            })
        );
    }

    // Product features
    createProductFeatures();

    // How it works
    createHowItWorksCarousel(document.querySelector('[data-hiw]'));

    // horizontally scrollable elements
    initDesignerQuotesList();
    createScrollableElements();

    // Example designs
    scrollOnHover('[data-scrollable="examples"]');
    centerAlignScrollableElement('[data-scrollable="examples"]').then(el => {
        const designCards = document.querySelectorAll('[data-design-card]');

        for (var i = 0; i < designCards.length; i++) {
            designCards[i].style.visibility = 'visible';
        }
    });

    // Contest listings
    scrollOnHover('[data-scrollable="contests"]');
    centerAlignScrollableElement('[data-scrollable="contests"]');

    centerAlignScrollableElement('[data-scrollable="options"]');
    scrollOnHover('[data-scrollable="options"]');

    // Hero carousel
    HeroCarousel.create().start();

    // FAQs
    Accordion.create();
});

// Initialise design galleries
document.addEventListener('DOMContentLoaded', () => {
    const galleries = document.querySelectorAll('[data-slide-carousel]');

    Array.from(galleries).forEach(
        gallery =>
            new SlideCarousel({
                element: gallery,
                stepElement: gallery.querySelector('[data-carousel-steps]'),
                stepClickEventMessage: 'Clicked Gallery Control On Designer List',
            })
    );
});

// Track scroll position
document.addEventListener('DOMContentLoaded', () => {
    new ScrollDepthTracking('Product Page');
});

// Sticky nav
document.addEventListener('DOMContentLoaded', () => {
    const interactiveElement = document.querySelector('[data-get-started-interactive]');

    new StickyBar(
        '[data-sticky-bar]',
        once(() => {
            trackEvent('Viewed Sticky Nav on Product Page');
        })
    );

    createStickyNavWaypoints();

    // Tracking
    const stickyNavCTA = document.querySelectorAll('[data-sticky-nav-item]');

    Array.from(stickyNavCTA).forEach(cta => {
        cta.addEventListener('click', e => {
            if (interactiveElement) {
                e.preventDefault();
            }

            trackEvent('Clicked Sticky Nav Item on Product Page', {
                name: cta.getAttribute('data-sticky-nav-item'),
            });
        });
    });
});

function createStickyNavWaypoints() {
    const offsetTop = 90; // sticky nav bar is 86px height, we need offset top to show the section heading
    const sectionElementAttributes = [
        '[data-trackable-section="featured-contests-carousel"]',
        '[data-trackable-section="how-it-works"]',
        '[data-trackable-section="customer-testimonial"]',
        '[data-trackable-section="pricing"]',
    ];

    sectionElementAttributes.forEach((attr, index) => {
        const element = document.querySelector(attr);

        if (element) {
            new Waypoint({
                element: element,
                handler: () => updateColor(element),
                offset: offsetTop,
            });

            // this is for scrolling up from bottom to top
            if (index < sectionElementAttributes.length - 1) {
                new Waypoint({
                    element: element,
                    handler: () => updateColor(element),
                    offset: () => {
                        return -element.clientHeight;
                    },
                });
            }
        } else {
            // hide the sticky nav tab
            const sectionId = attr.split('"')[1];
            const stickyNavItem = document.querySelector(`[data-page-nav-item="${sectionId}"]`);

            if (stickyNavItem) {
                stickyNavItem.setAttribute('data-hidden', '');
            }
        }
    });
}

function updateColor(element) {
    const color = '#ff7e65';
    const sectionId = element.getAttribute('data-trackable-section');
    const activeElement = document.querySelector(`[data-page-nav-item="${sectionId}"]`);

    if (activeElement) {
        activeElement.setAttribute('data-active', 'true');
        activeElement.style.color = color;
    }

    const navElements = document.querySelectorAll('[data-page-nav-item]');
    navElements.forEach(el => {
        if (el !== activeElement) {
            el.removeAttribute('data-active');
            el.removeAttribute('style');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-scrollto]');

    for (const element of elements) {
        const offsetTop = element.hasAttribute('data-scrollOffset')
            ? element.getAttribute('data-scrollOffset')
            : 0;
        new ScrollToElement(element, offsetTop).handleClick();
    }
});
